/**
 * FAQ Data
 * Frequently asked questions
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const faqs = [
  {
    id: "1",
    question: "What is Naori Detox?",
    answer:
      "<p>Naori Detox is a concentrated liquid chlorophyll formula designed to support natural detoxification, reduce bloating, and help you feel visibly lighter from within. Each 60 ml bottle provides 30 servings of a clean, 3-ingredient blend: chlorophyllin, organic peppermint oil, and organic vegetable glycerin.</p>",
  },
  {
    id: "2",
    question: "How do I take it?",
    answer:
      "<p>2 ml daily using the precision glass dropper, which is marked every 0.25 ml so you can dose accurately. Take it straight under the tongue, drop it into water, or add it to a smoothie. Most customers take it with breakfast to build a consistent habit.</p>",
  },
  {
    id: "3",
    question: "Can I take it with my morning coffee or tea?",
    answer:
      "<p>Yes. There's no issue taking Naori Detox alongside coffee or tea. Some people take their drops first, then have their coffee. Others mix it into a glass of water and drink it alongside breakfast. Whatever fits your routine.</p><p>For optimal results, we recommend taking <strong>Naori probiotics for at least 3 months</strong>. Along the way, here's what you may start experiencing:</p><ul><li>More stable energy throughout the day</li><li>Smoother, more comfortable digestion</li><li>Less gut discomfort (such as bloating or gas)</li><li>Better appetite control and fewer cravings</li></ul>",
  },
  {
    id: "4",
    question: "How quickly will I notice a difference?",
    answer:
      "<p>Most people feel less bloated within the first 1–2 weeks. For weight management and skin improvements, give it at least 4-6 weeks of consistent daily use alongside balanced eating and regular movement. Everyone's body responds differently, so some notice changes sooner than others.</p>",
  },
  {
    id: "5",
    question: "What does it taste like?",
    answer:
      "<p>Refreshing and mildly minty thanks to the organic peppermint oil. If you're sensitive to taste, mixing it into water or a smoothie helps.</p><p>In addition, maintaining a balanced gut microbiome has been linked to a lower risk of certain chronic conditions, including heart disease and type 2 diabetes.</p>",
  },
  {
    id: "6",
    question: "Is it safe to take every day? What about dietary restrictions?",
    answer:
      "<p>Yes. The formula contains three clean, well-studied ingredients with no stimulants, laxatives, or artificial additives. Chlorophyllin has been used safely in humans for over 50 years. Naori Detox is vegan, gluten-free, dairy-free, soy-free, and contains no major allergens.</p>",
  },
  {
    id: "7",
    question: "Can I take this alongside my medications?",
    answer:
      "<p>Naori Detox contains gentle, natural ingredients, but if you're currently on prescription medication – especially blood pressure, thyroid, or blood-thinning medications – please check with your healthcare provider before starting. This is standard advice for any new supplement.</p>",
  },
  {
    id: "8",
    question: "Will this help with menopause-related bloating and weight gain?",
    answer:
      "<p>Many of our customers are going through perimenopause or menopause and report noticeable improvements in bloating, water retention, and that stubborn midsection weight that showed up seemingly overnight. The formula supports your body's natural processes during a time when those processes tend to slow down.</p>",
  },
  {
    id: "9",
    question: "How is this different from a juice cleanse or detox tea?",
    answer:
      "<p>Those approaches are aggressive, short-term, and often leave you drained, cramping, or running to the bathroom. Naori Detox works gently with your body's own cleansing systems. There is no fasting, discomfort, or dramatic lifestyle changes; you just take 2 ml a day to support internal cleansing.</p>",
  },
  {
    id: "10",
    question: "Will it help with my skin?",
    answer:
      "<p>Many customers see clearer, brighter-looking skin within weeks. Chlorophyllin is a potent antioxidant with anti-inflammatory properties – published research in the Journal of Drugs in Dermatology showed improvements in skin clarity in as little as three weeks.</p>",
  },
  {
    id: "11",
    question:
      "Will it stain my teeth, clothes, or countertop? And what about the green color in general?",
    answer:
      "<p>The vivid green comes from chlorophyllin, the active ingredient, and is completely natural. It rinses off surfaces easily and won't stain teeth. Just avoid letting spills dry on light fabrics or porous countertops. You may also notice a slight green tint when you go to the bathroom. This is totally normal and a sign that the chlorophyllin is moving through your system.</p>",
  },
  {
    id: "12",
    question: "Can I combine this with other Naori products?",
    answer:
      "<p>Yes. Naori Detox pairs well with other products in the Naori range. If you're unsure which combination is right for you, take our quiz for a personalized recommendation.</p>",
  },
];

export default faqs;
